import { defineMessages, IntlProvider } from 'react-intl';

import CallQueueReport from './data-sources/CallQueueReport';
import CallQueueReportPercent from './data-sources/CallQueueReportPercent';
import Chart from '../models/Chart';
import ChartOption from '../models/ChartOption';

const messages = defineMessages({
  AGGREGATED: {
    id: 'AGGREGATED',
    defaultMessage: 'Aggregate',
  },
  PER_AGENT: {
    id: 'PER_AGENT',
    defaultMessage: 'Per Agent',
  },
  PER_QUEUE: {
    id: 'PER_QUEUE',
    defaultMessage: 'Per Queue',
  },
});

/**
 * Returns line chart manifest
 * @param locale
 * @returns {Chart}
 */
// eslint-disable-next-line import/prefer-default-export
export const initResponsiveLine = (locale = 'en_us') => {
  const { intl } = new IntlProvider({
    locale,
    messages,
  }, {}).getChildContext();

  /**
   * default values for required query parameters
   * @type {{time_range: string}}
   */
  const queryParams = {
    time_range: '1_day',
  };

  /**
   * Displays chart options to the user
   * type: timeRange displays an input and sets the start/end for the api request
   * type: queueFilter displays an input and sets the queue/s for the api request
   */
  const chartOptions = [
    new ChartOption({ type: 'timeRange', required: true }),
    new ChartOption({ type: 'queueFilter', required: false }),
  ];

  // construct and merge data options
  const callQueueReport = new CallQueueReport(intl);
  const callQueueReportPercent = new CallQueueReportPercent(intl);
  const dataOptions = { ...callQueueReport.dataOptions, ...callQueueReportPercent.dataOptions };

  /**
   * @type {Chart}
   */
  return new Chart({
    type: 'ResponsiveLine',
    chartOptions,
    dataOptions,
    queryParams,
    usesTimeRange: true,
    multipleSourceSupport: true,
    alertSupport: true,
  });
};
